(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["loyalty-earn-cards"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  /* ========================================================
     CAROUSEL
     ======================================================== */

  document
    .querySelectorAll('.loyalty-earn-carousel')
    .forEach(function (carousel) {

      const track =
        carousel.querySelector(
          '.loyalty-earn-carousel__track'
        );

      const prev =
        carousel.querySelector(
          '.loyalty-earn-carousel__nav--prev'
        );

      const next =
        carousel.querySelector(
          '.loyalty-earn-carousel__nav--next'
        );

      const cards =
        carousel.querySelectorAll(
          '.loyalty-earn-carousel__card'
        );


      if (!track || !prev || !next) {
        return;
      }


      function getCardWidth() {

        const card =
          track.querySelector(
            '.loyalty-earn-carousel__card'
          );


        if (!card) {
          return 300;
        }


        const styles =
          window.getComputedStyle(track);


        const gap =
          parseFloat(
            styles.columnGap || styles.gap
          ) || 20;


        return (
          card.getBoundingClientRect().width +
          gap
        );

      }


      function scrollByCard(direction) {

        track.scrollBy({
          left:
            direction *
            getCardWidth(),

          behavior: 'smooth'
        });

      }


      function updateCarouselState() {

        const maxScroll =
          track.scrollWidth -
          track.clientWidth;


        const currentScroll =
          track.scrollLeft;


        const canScroll =
          maxScroll > 5;


        const isSmallScreen =
          window.innerWidth <= 990;


        const shouldShowArrows =
          canScroll &&
          (
            cards.length > 4 ||
            isSmallScreen
          );


        carousel.classList.toggle(
          'show-arrows',
          shouldShowArrows
        );


        const hasMoreLeft =
          shouldShowArrows &&
          currentScroll > 8;


        const hasMoreRight =
          shouldShowArrows &&
          currentScroll <
            maxScroll - 8;


        prev.classList.toggle(
          'is-disabled',
          !hasMoreLeft
        );


        next.classList.toggle(
          'is-disabled',
          !hasMoreRight
        );

      }


      prev.addEventListener(
        'click',
        function () {
          scrollByCard(-1);
        }
      );


      next.addEventListener(
        'click',
        function () {
          scrollByCard(1);
        }
      );


      track.addEventListener(
        'scroll',
        updateCarouselState,
        { passive: true }
      );


      window.addEventListener(
        'resize',
        updateCarouselState
      );


      updateCarouselState();


      setTimeout(
        updateCarouselState,
        300
      );


      setTimeout(
        updateCarouselState,
        1000
      );

    });



  /* ========================================================
     LOYALTYLION ACTION BRIDGE
     ======================================================== */

  function normalizeRuleTitle(value) {

    return (value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');

  }


  function findNativeRule(
    section,
    requestedTitle
  ) {

    const wanted =
      normalizeRuleTitle(
        requestedTitle
      );


    if (!wanted) {
      return null;
    }


    const nativeRules =
      section.querySelectorAll(
        '.loyalty-native-rule-source .lion-rule-item'
      );


    for (const nativeRule of nativeRules) {

      const title =
        nativeRule.querySelector(
          '.lion-rule-item__title'
        );


      if (!title) {
        continue;
      }


      if (
        normalizeRuleTitle(
          title.textContent
        ) === wanted
      ) {
        return nativeRule;
      }

    }


    return null;

  }


  function populateNativePoints(section) {

    section
      .querySelectorAll(
        '[data-native-rule-title]'
      )
      .forEach(
        function (customCard) {

          const requestedTitle =
            customCard.dataset
              .nativeRuleTitle;


          const nativeRule =
            findNativeRule(
              section,
              requestedTitle
            );


          if (!nativeRule) {
            return;
          }


          const customPoints =
            customCard.querySelector(
              '[data-native-points]'
            );


          if (!customPoints) {
            return;
          }


          if (
            customPoints.dataset
              .hasCustomPoints ===
            'true'
          ) {
            return;
          }


          const nativePoints =
            nativeRule.querySelector(
              '.lion-rule-item__points'
            );


          if (
            nativePoints &&
            nativePoints.textContent.trim()
          ) {

            customPoints.textContent =
              nativePoints.textContent.trim();


            customPoints.hidden = false;

          }

        }
      );

  }


  function bindNativeButtons(section) {

    section
      .querySelectorAll(
        '[data-trigger-native-rule]'
      )
      .forEach(
        function (button) {

          if (
            button.dataset.nativeBound ===
            'true'
          ) {
            return;
          }


          button.dataset.nativeBound =
            'true';


          button.addEventListener(
            'click',
            function () {

              const requestedTitle =
                button.dataset
                  .triggerNativeRule;


              const nativeRule =
                findNativeRule(
                  section,
                  requestedTitle
                );


              if (!nativeRule) {

                console.warn(
                  'RealFaith Rewards: LoyaltyLion rule not found:',
                  requestedTitle
                );

                return;

              }


              const nativeButton =
                nativeRule.querySelector(
                  '.lion-action-button'
                );


              if (nativeButton) {
                nativeButton.click();
              }

            }
          );

        }
      );

  }


  function initializeCustomRules() {

    document
      .querySelectorAll(
        '[data-loyalty-earn-section]'
      )
      .forEach(
        function (section) {

          populateNativePoints(
            section
          );


          bindNativeButtons(
            section
          );

        }
      );

  }


  initializeCustomRules();


  const observer =
    new MutationObserver(
      function () {
        initializeCustomRules();
      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


  window.addEventListener(
    'load',
    function () {

      initializeCustomRules();


      setTimeout(
        initializeCustomRules,
        500
      );


      setTimeout(
        initializeCustomRules,
        1500
      );

    }
  );

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty-earn-highlighted"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  document
    .querySelectorAll('.loyalty-earn-carousel')
    .forEach(function (carousel) {

      const track =
        carousel.querySelector('.loyalty-earn-carousel__track');

      const prev =
        carousel.querySelector('.loyalty-earn-carousel__nav--prev');

      const next =
        carousel.querySelector('.loyalty-earn-carousel__nav--next');

      const cards =
        carousel.querySelectorAll('.loyalty-earn-carousel__card');


      if (!track || !prev || !next) return;


      function getCardWidth() {

        const card =
          track.querySelector('.loyalty-earn-carousel__card');

        if (!card) return 300;


        const styles =
          window.getComputedStyle(track);


        const gap =
          parseFloat(styles.gap) || 20;


        return card.getBoundingClientRect().width + gap;
      }


      function scrollByCard(direction) {

        track.scrollBy({
          left: direction * getCardWidth(),
          behavior: 'smooth'
        });

      }


      function updateState() {

        const maxScroll =
          track.scrollWidth - track.clientWidth;

        const current =
          track.scrollLeft;

        const canScroll =
          maxScroll > 5;

        const smallScreen =
          window.innerWidth <= 990;

        const show =
          canScroll &&
          (
            cards.length > 4 ||
            smallScreen
          );


        carousel.classList.toggle(
          'show-arrows',
          show
        );


        prev.classList.toggle(
          'is-disabled',
          !show || current <= 8
        );


        next.classList.toggle(
          'is-disabled',
          !show || current >= maxScroll - 8
        );

      }


      prev.addEventListener('click', function () {
        scrollByCard(-1);
      });


      next.addEventListener('click', function () {
        scrollByCard(1);
      });


      track.addEventListener(
        'scroll',
        updateState,
        { passive: true }
      );


      window.addEventListener(
        'resize',
        updateState
      );


      updateState();

      setTimeout(updateState, 300);

      setTimeout(updateState, 1000);

    });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty-earn-points-hub-v2"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  /* ==========================================================
     SHOPIFY THEME EDITOR PROTECTION
     ========================================================== */

  if (window.Shopify && window.Shopify.designMode) {
    console.log('Earn Points Hub: Shopify editor mode detected');
    return;
  }


  /* ==========================================================
     HELPERS
     ========================================================== */

  function normalize(value) {
    return (value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function getNativeButton(rule) {
    if (!rule) return null;

    return rule.querySelector(
      '[data-testid="rule-item-button"], ' +
      '.lion-rule-item__button, ' +
      '.lion-action-button, ' +
      'button, ' +
      'a[role="button"]'
    );
  }

  function isCompleted(button) {
  if (!button) return false;

  const text = normalize(button.textContent);

  return (
    button.classList.contains('lion-rule-item__completed') ||
    button.closest('.lion-rule-item__completed') !== null ||
    text === 'completed' ||
    text === 'complete' ||
    text === 'already completed' ||
    /^\d+\s+days?$/.test(text)
  );
}

  function isDisabled(button) {
    if (!button) return true;

    return (
      button.disabled === true ||
      button.getAttribute('aria-disabled') === 'true'
    );
  }


  /* ==========================================================
     FIND LOYALTYLION RULE
     ========================================================== */

  function findRule(section, requestedTitle) {

    const wanted = normalize(requestedTitle);

    if (!wanted) return null;

    const rules = section.querySelectorAll(
      '.loyalty-earn-hub__native .lion-rule-item'
    );

    for (const rule of rules) {

      const title = rule.querySelector(
        '.lion-rule-item__title'
      );

      if (!title) continue;

      if (normalize(title.textContent) === wanted) {
        return rule;
      }
    }

    return null;
  }


  /* ==========================================================
     SYNC CUSTOM CARD WITH LOYALTYLION
     ========================================================== */

  function syncItem(section, item) {

    const ruleTitle = item.dataset.nativeRuleTitle;

    if (!ruleTitle) return;

    const rule = findRule(section, ruleTitle);

    if (!rule) return;

    const points = item.querySelector(
      '[data-native-points]'
    );

    if (
      points &&
      points.dataset.hasCustomPoints !== 'true'
    ) {

      const nativePoints = rule.querySelector(
        '.lion-rule-item__points'
      );

      if (
        nativePoints &&
        nativePoints.textContent.trim()
      ) {
        points.textContent = nativePoints.textContent.trim();
        points.hidden = false;
      }
    }

    const customAction = item.querySelector(
      '[data-trigger-native-rule]'
    );

    if (!customAction) return;

    const nativeButton = getNativeButton(rule);

    if (!nativeButton) return;

    const completed = isCompleted(nativeButton);

    if (completed) {

      customAction.textContent = 'Completed';
      customAction.classList.add('is-complete');
      customAction.disabled = true;

    } else {

      // Restore availability when LoyaltyLion changes state.
      // Preserve the original label when possible.

      if (!customAction.dataset.originalLabel) {
        customAction.dataset.originalLabel =
          customAction.textContent.trim();
      }

      customAction.textContent =
        customAction.dataset.originalLabel;

      customAction.classList.remove('is-complete');

      if ('disabled' in customAction) {
        customAction.disabled = false;
      }
    }
  }


  /* ==========================================================
     INITIALIZE EARN POINTS HUB
     ========================================================== */

  function initializeSection(section) {

    section
      .querySelectorAll('[data-native-rule-title]')
      .forEach(function (item) {
        syncItem(section, item);
      });
  }

  function initializeAll() {

    document
      .querySelectorAll('[data-loyalty-earn-hub]')
      .forEach(initializeSection);
  }


  /* ==========================================================
     CUSTOM BUTTON -> NATIVE LOYALTYLION ACTION
     ========================================================== */

  document.addEventListener('click', function (event) {

    const trigger = event.target.closest(
      '[data-trigger-native-rule]'
    );

    if (!trigger) return;

    const section = trigger.closest(
      '[data-loyalty-earn-hub]'
    );

    if (!section) return;

    event.preventDefault();

    const requestedTitle =
      trigger.dataset.triggerNativeRule;

    const rule = findRule(
      section,
      requestedTitle
    );

    if (!rule) {

    if (window.RealFaithCustomerLoggedIn === false) {
      const returnUrl = encodeURIComponent(
        window.location.pathname + window.location.search
      );

      window.location.href =
        '/account/login?return_url=' + returnUrl;

      return;
    }

    console.warn(
      'RealFaith Membership: LoyaltyLion rule not found:',
      requestedTitle
    );

    return;
  }

    if (!rule) {

      console.warn(
        'RealFaith Membership: LoyaltyLion rule not found:',
        requestedTitle
      );

      return;
    }

    const nativeButton = getNativeButton(rule);

    if (!nativeButton) {

    if (window.RealFaithCustomerLoggedIn === false) {

      const returnUrl = encodeURIComponent(
        window.location.pathname + window.location.search
      );

      window.location.href =
        '/account/login?return_url=' + returnUrl;

      return;
    }

    console.warn(
      'RealFaith Membership: Native action button not found:',
      requestedTitle
    );

    return;
  }

    if (isCompleted(nativeButton)) {

      console.log(
        'RealFaith Membership: Action already completed:',
        requestedTitle
      );

      initializeSection(section);

      return;
    }

    if (isDisabled(nativeButton)) {

      console.warn(
        'RealFaith Membership: Native action is disabled:',
        requestedTitle
      );

      return;
    }

    console.log(
      'RealFaith Membership: Triggering native action:',
      requestedTitle
    );

    nativeButton.click();

    // Refresh custom card state after LoyaltyLion responds.

    setTimeout(function () {
      initializeSection(section);
    }, 500);

    setTimeout(function () {
      initializeSection(section);
    }, 1500);

  });


  /* ==========================================================
     INITIAL SYNC
     ========================================================== */

  initializeAll();

  setTimeout(initializeAll, 400);
  setTimeout(initializeAll, 1000);
  setTimeout(initializeAll, 2000);
  setTimeout(initializeAll, 4000);


  /* ==========================================================
     LOYALTYLION ASYNC RENDERING
     ========================================================== */

  const hubs = document.querySelectorAll(
    '[data-loyalty-earn-hub]'
  );

  hubs.forEach(function (section) {

    const nativeContainer = section.querySelector(
      '.loyalty-earn-hub__native'
    );

    if (!nativeContainer) return;

    let syncScheduled = false;

    const observer = new MutationObserver(function () {

      if (syncScheduled) return;

      syncScheduled = true;

      requestAnimationFrame(function () {

        syncScheduled = false;
        initializeSection(section);

      });

    });

    observer.observe(nativeContainer, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: [
        'disabled',
        'aria-disabled',
        'class'
      ]
    });

  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty-earn-points-hub"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  /* ==========================================================
     SHOPIFY THEME EDITOR PROTECTION
     ========================================================== */

  if (window.Shopify && window.Shopify.designMode) {
    console.log('Earn Points Hub: Shopify editor mode detected');
    return;
  }


  /* ==========================================================
     HELPERS
     ========================================================== */

  function normalize(value) {
    return (value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function getNativeButton(rule) {
    if (!rule) return null;

    return rule.querySelector(
      '[data-testid="rule-item-button"], ' +
      '.lion-rule-item__button, ' +
      '.lion-action-button, ' +
      'button, ' +
      'a[role="button"]'
    );
  }

  function isCompleted(button) {
  if (!button) return false;

  const text = normalize(button.textContent);

  return (
    button.classList.contains('lion-rule-item__completed') ||
    button.closest('.lion-rule-item__completed') !== null ||
    text === 'completed' ||
    text === 'complete' ||
    text === 'already completed' ||
    /^\d+\s+days?$/.test(text)
  );
}

  function isDisabled(button) {
    if (!button) return true;

    return (
      button.disabled === true ||
      button.getAttribute('aria-disabled') === 'true'
    );
  }


  /* ==========================================================
     FIND LOYALTYLION RULE
     ========================================================== */

  function findRule(section, requestedTitle) {

    const wanted = normalize(requestedTitle);

    if (!wanted) return null;

    const rules = section.querySelectorAll(
      '.loyalty-earn-hub__native .lion-rule-item'
    );

    for (const rule of rules) {

      const title = rule.querySelector(
        '.lion-rule-item__title'
      );

      if (!title) continue;

      if (normalize(title.textContent) === wanted) {
        return rule;
      }
    }

    return null;
  }


  /* ==========================================================
     SYNC CUSTOM CARD WITH LOYALTYLION
     ========================================================== */

  function syncItem(section, item) {

    const ruleTitle = item.dataset.nativeRuleTitle;

    if (!ruleTitle) return;

    const rule = findRule(section, ruleTitle);

    if (!rule) return;

    const points = item.querySelector(
      '[data-native-points]'
    );

    if (
      points &&
      points.dataset.hasCustomPoints !== 'true'
    ) {

      const nativePoints = rule.querySelector(
        '.lion-rule-item__points'
      );

      if (
        nativePoints &&
        nativePoints.textContent.trim()
      ) {
        points.textContent = nativePoints.textContent.trim();
        points.hidden = false;
      }
    }

    const customAction = item.querySelector(
      '[data-trigger-native-rule]'
    );

    if (!customAction) return;

    const nativeButton = getNativeButton(rule);

    if (!nativeButton) return;

    const completed = isCompleted(nativeButton);

    if (completed) {

      customAction.textContent = 'Completed';
      customAction.classList.add('is-complete');
      customAction.disabled = true;

    } else {

      // Restore availability when LoyaltyLion changes state.
      // Preserve the original label when possible.

      if (!customAction.dataset.originalLabel) {
        customAction.dataset.originalLabel =
          customAction.textContent.trim();
      }

      customAction.textContent =
        customAction.dataset.originalLabel;

      customAction.classList.remove('is-complete');

      if ('disabled' in customAction) {
        customAction.disabled = false;
      }
    }
  }


  /* ==========================================================
     INITIALIZE EARN POINTS HUB
     ========================================================== */

  function initializeSection(section) {

    section
      .querySelectorAll('[data-native-rule-title]')
      .forEach(function (item) {
        syncItem(section, item);
      });
  }

  function initializeAll() {

    document
      .querySelectorAll('[data-loyalty-earn-hub]')
      .forEach(initializeSection);
  }


  /* ==========================================================
     CUSTOM BUTTON -> NATIVE LOYALTYLION ACTION
     ========================================================== */

  document.addEventListener('click', function (event) {

    const trigger = event.target.closest(
      '[data-trigger-native-rule]'
    );

    if (!trigger) return;

    const section = trigger.closest(
      '[data-loyalty-earn-hub]'
    );

    if (!section) return;

    event.preventDefault();

    const requestedTitle =
      trigger.dataset.triggerNativeRule;

    const rule = findRule(
      section,
      requestedTitle
    );

    if (!rule) {

    if (window.RealFaithCustomerLoggedIn === false) {
      const returnUrl = encodeURIComponent(
        window.location.pathname + window.location.search
      );

      window.location.href =
        '/account/login?return_url=' + returnUrl;

      return;
    }

    console.warn(
      'RealFaith Membership: LoyaltyLion rule not found:',
      requestedTitle
    );

    return;
  }

    if (!rule) {

      console.warn(
        'RealFaith Membership: LoyaltyLion rule not found:',
        requestedTitle
      );

      return;
    }

    const nativeButton = getNativeButton(rule);

    if (!nativeButton) {

    if (window.RealFaithCustomerLoggedIn === false) {

      const returnUrl = encodeURIComponent(
        window.location.pathname + window.location.search
      );

      window.location.href =
        '/account/login?return_url=' + returnUrl;

      return;
    }

    console.warn(
      'RealFaith Membership: Native action button not found:',
      requestedTitle
    );

    return;
  }

    if (isCompleted(nativeButton)) {

      console.log(
        'RealFaith Membership: Action already completed:',
        requestedTitle
      );

      initializeSection(section);

      return;
    }

    if (isDisabled(nativeButton)) {

      console.warn(
        'RealFaith Membership: Native action is disabled:',
        requestedTitle
      );

      return;
    }

    console.log(
      'RealFaith Membership: Triggering native action:',
      requestedTitle
    );

    nativeButton.click();

    // Refresh custom card state after LoyaltyLion responds.

    setTimeout(function () {
      initializeSection(section);
    }, 500);

    setTimeout(function () {
      initializeSection(section);
    }, 1500);

  });


  /* ==========================================================
     INITIAL SYNC
     ========================================================== */

  initializeAll();

  setTimeout(initializeAll, 400);
  setTimeout(initializeAll, 1000);
  setTimeout(initializeAll, 2000);
  setTimeout(initializeAll, 4000);


  /* ==========================================================
     LOYALTYLION ASYNC RENDERING
     ========================================================== */

  const hubs = document.querySelectorAll(
    '[data-loyalty-earn-hub]'
  );

  hubs.forEach(function (section) {

    const nativeContainer = section.querySelector(
      '.loyalty-earn-hub__native'
    );

    if (!nativeContainer) return;

    let syncScheduled = false;

    const observer = new MutationObserver(function () {

      if (syncScheduled) return;

      syncScheduled = true;

      requestAnimationFrame(function () {

        syncScheduled = false;
        initializeSection(section);

      });

    });

    observer.observe(nativeContainer, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: [
        'disabled',
        'aria-disabled',
        'class'
      ]
    });

  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty-page-nav-v2"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  const links =
    document.querySelectorAll(
      '.loyalty-page-nav__link'
    );


  if (!links.length) return;


  /* ==========================================================
     SMOOTH SCROLL
     Only applies to #anchor links.
     Page links continue normally.
     ========================================================== */

  links.forEach(function (link) {

    link.addEventListener(
      'click',
      function (event) {

        const href =
          link.getAttribute('href');


        if (
          !href ||
          !href.startsWith('#')
        ) {
          return;
        }


        const target =
          document.querySelector(href);


        if (!target) {
          return;
        }


        event.preventDefault();


        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

      }
    );

  });


  /* ==========================================================
     ACTIVE SECTION
     Only monitor anchor links that exist on this page.
     ========================================================== */

  const sections = [];


  links.forEach(function (link) {

    const href =
      link.getAttribute('href');


    if (
      !href ||
      !href.startsWith('#')
    ) {
      return;
    }


    const target =
      document.querySelector(href);


    if (target) {

      sections.push({
        link: link,
        target: target
      });

    }

  });


  if (!sections.length) {
    return;
  }


  const observer =
    new IntersectionObserver(
      function (entries) {

        entries.forEach(
          function (entry) {

            if (!entry.isIntersecting) {
              return;
            }


            sections.forEach(
              function (item) {

                item.link.classList.remove(
                  'is-active'
                );

              }
            );


            const match =
              sections.find(
                function (item) {

                  return (
                    item.target ===
                    entry.target
                  );

                }
              );


            if (match) {

              match.link.classList.add(
                'is-active'
              );

            }

          }
        );

      },
      {
        rootMargin:
          '-25% 0px -60% 0px',

        threshold: 0
      }
    );


  sections.forEach(
    function (item) {

      observer.observe(
        item.target
      );

    }
  );

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty-page-nav"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  const links =
    document.querySelectorAll(
      '.loyalty-page-nav__link'
    );


  if (!links.length) return;


  /* ==========================================================
     SMOOTH SCROLL
     Only applies to #anchor links.
     Page links continue normally.
     ========================================================== */

  links.forEach(function (link) {

    link.addEventListener(
      'click',
      function (event) {

        const href =
          link.getAttribute('href');


        if (
          !href ||
          !href.startsWith('#')
        ) {
          return;
        }


        const target =
          document.querySelector(href);


        if (!target) {
          return;
        }


        event.preventDefault();


        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

      }
    );

  });


  /* ==========================================================
     ACTIVE SECTION
     Only monitor anchor links that exist on this page.
     ========================================================== */

  const sections = [];


  links.forEach(function (link) {

    const href =
      link.getAttribute('href');


    if (
      !href ||
      !href.startsWith('#')
    ) {
      return;
    }


    const target =
      document.querySelector(href);


    if (target) {

      sections.push({
        link: link,
        target: target
      });

    }

  });


  if (!sections.length) {
    return;
  }


  const observer =
    new IntersectionObserver(
      function (entries) {

        entries.forEach(
          function (entry) {

            if (!entry.isIntersecting) {
              return;
            }


            sections.forEach(
              function (item) {

                item.link.classList.remove(
                  'is-active'
                );

              }
            );


            const match =
              sections.find(
                function (item) {

                  return (
                    item.target ===
                    entry.target
                  );

                }
              );


            if (match) {

              match.link.classList.add(
                'is-active'
              );

            }

          }
        );

      },
      {
        rootMargin:
          '-25% 0px -60% 0px',

        threshold: 0
      }
    );


  sections.forEach(
    function (item) {

      observer.observe(
        item.target
      );

    }
  );

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty-perks-hub-v2"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  const hubs =
    document.querySelectorAll(
      '[data-loyalty-perks-hub]'
    );


  if (!hubs.length) return;



  /* ==========================================================
     TABS
     ========================================================== */

  function initializePerkTabs(hub) {

    const buttons =
      hub.querySelectorAll(
        '[data-perks-tab]'
      );


    const panels =
      hub.querySelectorAll(
        '[data-perks-panel]'
      );


    if (
      !buttons.length ||
      !panels.length
    ) {
      return;
    }


    buttons.forEach(function (button) {

      if (
        button.dataset.perksTabBound === 'true'
      ) {
        return;
      }


      button.dataset.perksTabBound =
        'true';


      button.addEventListener(
        'click',
        function () {

          const target =
            button.dataset.perksTab;


          buttons.forEach(function (item) {

            const active =
              item === button;


            item.classList.toggle(
              'is-active',
              active
            );


            item.setAttribute(
              'aria-selected',
              active ? 'true' : 'false'
            );

          });


          panels.forEach(function (panel) {

            const active =
              panel.dataset.perksPanel === target;


            panel.classList.toggle(
              'is-active',
              active
            );


            panel.hidden =
              !active;

          });

        }
      );

    });

  }



  /* ==========================================================
     CUSTOM ACTIVE REWARD IMAGES
     ========================================================== */

  function applyCustomImages(hub) {

    const mappings =
      hub.querySelectorAll(
        '[data-perk-reward-id]'
      );


    if (!mappings.length) return;


    mappings.forEach(function (mapping) {

      const rewardId =
        mapping.dataset.perkRewardId;


      const imageUrl =
        mapping.dataset.perkImage;


      const mode =
        mapping.dataset.perkImageMode || 'fallback';


      if (
        !rewardId ||
        !imageUrl
      ) {
        return;
      }


      const reward =
        hub.querySelector(
          '.lion-reward-item[data-reward-id="' +
          CSS.escape(rewardId) +
          '"]'
        );


      if (!reward) return;


      if (
        reward.dataset.customPerkImageApplied === 'true'
      ) {
        return;
      }


      const existingImageContainer =
        reward.querySelector(
          '.lion-reward-item__product-image'
        );


      const existingImage =
        existingImageContainer
          ? existingImageContainer.querySelector('img')
          : null;


      if (
        mode === 'fallback' &&
        existingImage &&
        existingImage.getAttribute('src')
      ) {

        reward.dataset.customPerkImageApplied =
          'true';

        return;

      }


      if (existingImage) {

        existingImage.src =
          imageUrl;


        existingImage.srcset =
          '';


        reward.dataset.customPerkImageApplied =
          'true';

        return;

      }


      const content =
        reward.querySelector(
          '.lion-reward-item__content'
        );


      if (!content) return;


      const customContainer =
        document.createElement('div');


      customContainer.className =
        'loyalty-perks-custom-image';


      const image =
        document.createElement('img');


      image.src =
        imageUrl;


      image.alt =
        '';


      image.loading =
        'lazy';


      customContainer.appendChild(
        image
      );


      content.prepend(
        customContainer
      );


      reward.dataset.customPerkImageApplied =
        'true';

    });

  }



  /* ==========================================================
     INITIALIZE
     ========================================================== */

  function initialize() {

    hubs.forEach(function (hub) {

      initializePerkTabs(hub);

      applyCustomImages(hub);

    });

  }


  initialize();



  /* LoyaltyLion injects content asynchronously */

  const observer =
    new MutationObserver(
      function () {
        initialize();
      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


  setTimeout(
    initialize,
    500
  );


  setTimeout(
    initialize,
    1500
  );

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty-perks-hub"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  const hubs =
    document.querySelectorAll(
      '[data-loyalty-perks-hub]'
    );


  if (!hubs.length) return;



  /* ==========================================================
     TABS
     ========================================================== */

  function initializePerkTabs(hub) {

    const buttons =
      hub.querySelectorAll(
        '[data-perks-tab]'
      );


    const panels =
      hub.querySelectorAll(
        '[data-perks-panel]'
      );


    if (
      !buttons.length ||
      !panels.length
    ) {
      return;
    }


    buttons.forEach(function (button) {

      if (
        button.dataset.perksTabBound === 'true'
      ) {
        return;
      }


      button.dataset.perksTabBound =
        'true';


      button.addEventListener(
        'click',
        function () {

          const target =
            button.dataset.perksTab;


          buttons.forEach(function (item) {

            const active =
              item === button;


            item.classList.toggle(
              'is-active',
              active
            );


            item.setAttribute(
              'aria-selected',
              active ? 'true' : 'false'
            );

          });


          panels.forEach(function (panel) {

            const active =
              panel.dataset.perksPanel === target;


            panel.classList.toggle(
              'is-active',
              active
            );


            panel.hidden =
              !active;

          });

        }
      );

    });

  }



  /* ==========================================================
     CUSTOM ACTIVE REWARD IMAGES
     ========================================================== */

  function applyCustomImages(hub) {

    const mappings =
      hub.querySelectorAll(
        '[data-perk-reward-id]'
      );


    if (!mappings.length) return;


    mappings.forEach(function (mapping) {

      const rewardId =
        mapping.dataset.perkRewardId;


      const imageUrl =
        mapping.dataset.perkImage;


      const mode =
        mapping.dataset.perkImageMode || 'fallback';


      if (
        !rewardId ||
        !imageUrl
      ) {
        return;
      }


      const reward =
        hub.querySelector(
          '.lion-reward-item[data-reward-id="' +
          CSS.escape(rewardId) +
          '"]'
        );


      if (!reward) return;


      if (
        reward.dataset.customPerkImageApplied === 'true'
      ) {
        return;
      }


      const existingImageContainer =
        reward.querySelector(
          '.lion-reward-item__product-image'
        );


      const existingImage =
        existingImageContainer
          ? existingImageContainer.querySelector('img')
          : null;


      if (
        mode === 'fallback' &&
        existingImage &&
        existingImage.getAttribute('src')
      ) {

        reward.dataset.customPerkImageApplied =
          'true';

        return;

      }


      if (existingImage) {

        existingImage.src =
          imageUrl;


        existingImage.srcset =
          '';


        reward.dataset.customPerkImageApplied =
          'true';

        return;

      }


      const content =
        reward.querySelector(
          '.lion-reward-item__content'
        );


      if (!content) return;


      const customContainer =
        document.createElement('div');


      customContainer.className =
        'loyalty-perks-custom-image';


      const image =
        document.createElement('img');


      image.src =
        imageUrl;


      image.alt =
        '';


      image.loading =
        'lazy';


      customContainer.appendChild(
        image
      );


      content.prepend(
        customContainer
      );


      reward.dataset.customPerkImageApplied =
        'true';

    });

  }



  /* ==========================================================
     INITIALIZE
     ========================================================== */

  function initialize() {

    hubs.forEach(function (hub) {

      initializePerkTabs(hub);

      applyCustomImages(hub);

    });

  }


  initialize();



  /* LoyaltyLion injects content asynchronously */

  const observer =
    new MutationObserver(
      function () {
        initialize();
      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


  setTimeout(
    initialize,
    500
  );


  setTimeout(
    initialize,
    1500
  );

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty-rewards-preview"] && !Shopify.designMode) return;
  try {
    

(function () {

  function applyRewardImages() {

    document.querySelectorAll('.loyalty-rewards').forEach(function(section) {

      const configs = section.querySelectorAll(
        '.rf-reward-image-config__item'
      );

      configs.forEach(function(config) {

        const rewardId = config.dataset.rewardId;
        const imageUrl = config.dataset.imageUrl;
        const mode = config.dataset.imageMode || 'fallback';
        const alt = config.dataset.imageAlt || '';

        if (!rewardId || !imageUrl) return;

        const reward = section.querySelector(
          '.lion-reward-item[data-reward-id="' + rewardId + '"]'
        );

        if (!reward) return;

        /*
         * Avoid creating the custom image more than once
         * when LoyaltyLion updates its DOM.
         */
        let customArtwork = reward.querySelector(
          '.rf-reward-custom-image'
        );

        const nativeProductImages = Array.from(
          reward.querySelectorAll('img')
        ).filter(function(img) {
          return !img.closest('.rf-reward-custom-image');
        });

        /*
         * FALLBACK:
         * If LL already supplied an actual product image,
         * leave the reward untouched.
         */
        if (
          mode === 'fallback' &&
          nativeProductImages.length > 0
        ) {
          return;
        }

        if (!customArtwork) {

          customArtwork = document.createElement('div');
          customArtwork.className = 'rf-reward-custom-image';

          const img = document.createElement('img');
          img.src = imageUrl;
          img.alt = alt;
          img.loading = 'lazy';

          customArtwork.appendChild(img);

          /*
           * Put artwork after the points/meta area.
           * This creates:
           *
           * Reward title
           * Points
           * Artwork
           * Links
           * Button
           */
          const meta = reward.querySelector(
            '.lion-reward-item__meta'
          );

          const title = reward.querySelector(
            '.lion-reward-item__title'
          );

          if (meta) {
            meta.insertAdjacentElement(
              'afterend',
              customArtwork
            );
          } else if (title) {
            title.insertAdjacentElement(
              'afterend',
              customArtwork
            );
          } else {
            const content = reward.querySelector(
              '.lion-reward-item__content'
            );

            if (content) {
              content.prepend(customArtwork);
            }
          }
        }

        /*
         * REPLACE:
         * Hide LoyaltyLion's native/product artwork.
         */
        if (mode === 'replace') {
          reward.classList.add(
            'rf-reward-image--replace'
          );
        } else {
          reward.classList.remove(
            'rf-reward-image--replace'
          );
        }

      });

    });

  }

  /* LoyaltyLion may already be rendered */
  applyRewardImages();

  /*
   * LoyaltyLion renders asynchronously and may re-render
   * after customer/reward state changes.
   */
  const observer = new MutationObserver(function() {
    applyRewardImages();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  window.addEventListener('load', function() {
    applyRewardImages();

    setTimeout(applyRewardImages, 500);
    setTimeout(applyRewardImages, 1500);
  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty-tiers-v2"] && !Shopify.designMode) return;
  try {
    

(function () {

  // Temporarily disable tier JavaScript inside Shopify Customize.
  if (window.Shopify && window.Shopify.designMode) {
    console.log('Loyalty Tiers: editor mode, skipping JS');
    return;
  }

  const tierData = {

    basic: {
      rank: 1,
      label: 'Basic'
    },

    remnant: {
      rank: 3,
      label: 'The Remnant'
    }

  };


  function normalize(value) {

    return (value || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');

  }


  function tierKeyFromTitle(title) {

    const value =
      normalize(title);


    if (
      value.indexOf('remnant') !== -1
    ) {
      return 'remnant';
    }


    if (
      value.indexOf('advanced') !== -1 ||
      value.indexOf('contributor') !== -1
    ) {
      // Legacy Contributor is shown as Basic, never as Remnant.
      return 'basic';
    }


    if (
      value.indexOf('basic') !== -1
    ) {
      return 'basic';
    }


    return null;

  }


  function detectCurrentTier(section) {

    const native =
      section.querySelector(
        '.loyalty-tiers__native-source'
      );


    if (!native) {
      return null;
    }


    const current =
      native.querySelector(
        '.lion-tier-box--current, .lion-tier-box--active'
      );


    if (!current) {
      return null;
    }


    const title =
      current.querySelector(
        '.lion-tier-box__title'
      );


    if (!title) {
      return null;
    }


    return tierKeyFromTitle(
      title.textContent
    );

  }


  function getTierCta(
    section,
    tier
  ) {

    if (tier === 'basic') {

      return {
        label:
          section.dataset.basicCtaLabel ||
          'Create an Account',

        link:
          section.dataset.basicCtaLink ||
          ''
      };

    }


    return {
      label:
        section.dataset.remnantCtaLabel ||
        'Join The Remnant',

      link:
        section.dataset.remnantCtaLink ||
        ''
    };

  }


  function renderTier(
    section,
    selectedTier,
    currentTier
  ) {

    const selectedData =
      tierData[selectedTier];


    if (!selectedData) {
      return;
    }


    const selectedRank =
      selectedData.rank;


    const currentData =
      currentTier
        ? tierData[currentTier]
        : null;


    const currentRank =
      currentData
        ? currentData.rank
        : null;


    const selectedCta =
      getTierCta(
        section,
        selectedTier
      );


    /* ======================================================
       SELECTORS
       ====================================================== */

    section
      .querySelectorAll(
        '[data-tier-selector]'
      )
      .forEach(function (button) {

        const key =
          button.dataset.tierSelector;


        button.classList.toggle(
          'is-selected',
          key === selectedTier
        );


        button.classList.toggle(
          'is-current',
          key === currentTier
        );


        button.setAttribute(
          'aria-selected',
          key === selectedTier
            ? 'true'
            : 'false'
        );

      });


    /* ======================================================
       DETAIL TITLE
       ====================================================== */

    const selectedButton =
      section.querySelector(
        '[data-tier-selector="' +
        selectedTier +
        '"]'
      );


    const detailTitle =
      section.querySelector(
        '[data-tier-detail-title]'
      );


    if (
      selectedButton &&
      detailTitle
    ) {

      const name =
        selectedButton.querySelector(
          '.loyalty-tier-selector__name'
        );


      if (name) {

        detailTitle.textContent =
          name.textContent.trim();

      }

    }


    /* ======================================================
       DESCRIPTION
       ====================================================== */

    section
      .querySelectorAll(
        '[data-tier-description]'
      )
      .forEach(function (description) {

        description.hidden =
          description.dataset.tierDescription !==
          selectedTier;

      });


    /* ======================================================
       PANEL STATUS
       ====================================================== */

    const status =
      section.querySelector(
        '[data-tier-detail-status]'
      );


    if (status) {

      if (
        currentTier &&
        selectedTier === currentTier
      ) {

        status.textContent =
          'Your Current Level';

      }

      else if (
        currentRank &&
        selectedRank < currentRank
      ) {

        status.textContent =
          'Previewing Level';

      }

      else if (
        currentRank &&
        selectedRank > currentRank
      ) {

        status.textContent =
          'Available to Unlock';

      }

      else {

        status.textContent =
          'Explore this level';

      }

    }


    /* ======================================================
       BENEFITS
       ====================================================== */

    section
      .querySelectorAll(
        '[data-tier-benefit]'
      )
      .forEach(function (benefit) {

        const requiredRank =
          parseInt(
            benefit.dataset.minimumRank,
            10
          ) || 1;


        const titleText = normalize(benefit.querySelector('.loyalty-tier-benefit__title')?.textContent);
        const monthlyResource = titleText.includes('monthly resource') || titleText.includes('free monthly resource');
        const included = monthlyResource
          ? selectedTier === 'remnant'
          : selectedRank >= requiredRank;


        benefit.classList.toggle(
          'is-active',
          included
        );


        benefit.classList.toggle(
          'is-locked',
          !included
        );


        const state =
          benefit.querySelector(
            '[data-benefit-state]'
          );


        if (!state) {
          return;
        }


        if (included) {

          if (
            currentTier &&
            selectedTier === currentTier
          ) {

            state.textContent =
              'Included for you';

          } else {

            state.textContent =
              'Included';

          }

        } else {

          const requiredTier =
            benefit.dataset.minimumTier;


          const requiredData =
            tierData[requiredTier];


            state.textContent =
              monthlyResource || requiredTier === 'advanced' || requiredTier === 'remnant'
                ? 'Available with The Remnant'
                : (requiredData ? 'Available at ' + requiredData.label : 'Not included');

        }

      });


    /* ======================================================
       FOOTER / CTA
       ====================================================== */

    const footerTitle =
      section.querySelector(
        '[data-tier-footer-title]'
      );


    const footerCopy =
      section.querySelector(
        '[data-tier-footer-copy]'
      );


    const cta =
      section.querySelector(
        '[data-tier-cta]'
      );


    if (!cta) {
      return;
    }


    cta.classList.remove(
      'is-current',
      'is-included'
    );


    /* Always restore link first */

    if (selectedCta.link) {

      cta.setAttribute(
        'href',
        selectedCta.link
      );

    } else {

      cta.removeAttribute(
        'href'
      );

    }


    /* ======================================================
       CURRENT TIER
       ====================================================== */

    if (
      currentTier &&
      selectedTier === currentTier
    ) {

      if (footerTitle) {

        footerTitle.textContent =
          'You are here';

      }


      if (footerCopy) {

        footerCopy.textContent =
          'These are the benefits available at your current level.';

      }


      cta.textContent =
        'Your Current Level';


      cta.removeAttribute(
        'href'
      );


      cta.classList.add(
        'is-current'
      );


      return;

    }


    /* ======================================================
       LOWER TIER ALREADY INCLUDED
       ====================================================== */

    if (
      currentRank &&
      selectedRank < currentRank
    ) {

      if (footerTitle) {

        footerTitle.textContent =
          selectedData.label +
          ' Benefits';

      }


      if (footerCopy) {

        footerCopy.textContent =
          'This level is already included within your current membership.';

      }


      cta.textContent =
        'Already Included';


      cta.removeAttribute(
        'href'
      );


      cta.classList.add(
        'is-included'
      );


      return;

    }


    /* ======================================================
       AVAILABLE / UPGRADE TIER
       ====================================================== */

    if (footerTitle) {

      footerTitle.textContent =
        selectedData.label +
        ' Benefits';

    }


    if (footerCopy) {

      if (
        currentRank &&
        selectedRank > currentRank
      ) {

        footerCopy.textContent =
          'Take the next step to unlock the additional benefits available at this level.';

      } else {

        footerCopy.textContent =
          'See what is included at this level and take the next step when you are ready.';

      }

    }


    cta.textContent =
      selectedCta.label;


    if (selectedCta.link) {

      cta.setAttribute(
        'href',
        selectedCta.link
      );

    } else {

      cta.removeAttribute(
        'href'
      );

    }

  }


  function initializeTierExperience(
    section
  ) {

    if (
      section.dataset.tierInitialized ===
      'true'
    ) {
      return;
    }


    const selectors =
      section.querySelectorAll(
        '[data-tier-selector]'
      );


    if (!selectors.length) {
      return;
    }


    section.dataset.tierInitialized =
      'true';


    let currentTier =
      detectCurrentTier(section);


    let selectedTier =
      currentTier || 'basic';


    selectors.forEach(
      function (button) {

        button.addEventListener(
          'click',
          function () {

            section.dataset.userSelectedTier =
              'true';


            selectedTier =
              button.dataset.tierSelector;


            currentTier =
              detectCurrentTier(section) ||
              currentTier;


            renderTier(
              section,
              selectedTier,
              currentTier
            );

          }
        );

      }
    );


    renderTier(
      section,
      selectedTier,
      currentTier
    );


    /* ======================================================
       WAIT FOR LOYALTYLION
       ====================================================== */

    const observer =
      new MutationObserver(
        function () {

          const detected =
            detectCurrentTier(section);


          if (
            detected &&
            detected !== currentTier
          ) {

            currentTier =
              detected;


            if (
              !section.dataset.userSelectedTier
            ) {

              selectedTier =
                currentTier;

            }


            renderTier(
              section,
              selectedTier,
              currentTier
            );

          }

        }
      );


    const native =
      section.querySelector(
        '.loyalty-tiers__native-source'
      );


    if (native) {

      observer.observe(
        native,
        {
          childList: true,
          subtree: true
        }
      );

    }

  }


  function initAll() {

    document
      .querySelectorAll(
        '[data-loyalty-tier-experience]'
      )
      .forEach(
        initializeTierExperience
      );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );

  } else {

    initAll();

  }

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty-tiers"] && !Shopify.designMode) return;
  try {
    

(function () {

  // Temporarily disable tier JavaScript inside Shopify Customize.
  if (window.Shopify && window.Shopify.designMode) {
    console.log('Loyalty Tiers: editor mode, skipping JS');
    return;
  }

  const tierData = {

    basic: {
      rank: 1,
      label: 'Basic'
    },

    advanced: {
      rank: 2,
      label: 'Contributor'
    },

    remnant: {
      rank: 3,
      label: 'The Remnant'
    }

  };


  function normalize(value) {

    return (value || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');

  }


  function tierKeyFromTitle(title) {

    const value =
      normalize(title);


    if (
      value.indexOf('remnant') !== -1
    ) {
      return 'remnant';
    }


    if (
      value.indexOf('advanced') !== -1 ||
      value.indexOf('contributor') !== -1
    ) {
      return 'advanced';
    }


    if (
      value.indexOf('basic') !== -1
    ) {
      return 'basic';
    }


    return null;

  }


  function detectCurrentTier(section) {

    const native =
      section.querySelector(
        '.loyalty-tiers__native-source'
      );


    if (!native) {
      return null;
    }


    const current =
      native.querySelector(
        '.lion-tier-box--current, .lion-tier-box--active'
      );


    if (!current) {
      return null;
    }


    const title =
      current.querySelector(
        '.lion-tier-box__title'
      );


    if (!title) {
      return null;
    }


    return tierKeyFromTitle(
      title.textContent
    );

  }


  function getTierCta(
    section,
    tier
  ) {

    if (tier === 'basic') {

      return {
        label:
          section.dataset.basicCtaLabel ||
          'Create an Account',

        link:
          section.dataset.basicCtaLink ||
          ''
      };

    }


    if (tier === 'advanced') {

      return {
        label:
          section.dataset.advancedCtaLabel ||
          'Become a Contributor',

        link:
          section.dataset.advancedCtaLink ||
          ''
      };

    }


    return {
      label:
        section.dataset.remnantCtaLabel ||
        'Join The Remnant',

      link:
        section.dataset.remnantCtaLink ||
        ''
    };

  }


  function renderTier(
    section,
    selectedTier,
    currentTier
  ) {

    const selectedData =
      tierData[selectedTier];


    if (!selectedData) {
      return;
    }


    const selectedRank =
      selectedData.rank;


    const currentData =
      currentTier
        ? tierData[currentTier]
        : null;


    const currentRank =
      currentData
        ? currentData.rank
        : null;


    const selectedCta =
      getTierCta(
        section,
        selectedTier
      );


    /* ======================================================
       SELECTORS
       ====================================================== */

    section
      .querySelectorAll(
        '[data-tier-selector]'
      )
      .forEach(function (button) {

        const key =
          button.dataset.tierSelector;


        button.classList.toggle(
          'is-selected',
          key === selectedTier
        );


        button.classList.toggle(
          'is-current',
          key === currentTier
        );


        button.setAttribute(
          'aria-selected',
          key === selectedTier
            ? 'true'
            : 'false'
        );

      });


    /* ======================================================
       DETAIL TITLE
       ====================================================== */

    const selectedButton =
      section.querySelector(
        '[data-tier-selector="' +
        selectedTier +
        '"]'
      );


    const detailTitle =
      section.querySelector(
        '[data-tier-detail-title]'
      );


    if (
      selectedButton &&
      detailTitle
    ) {

      const name =
        selectedButton.querySelector(
          '.loyalty-tier-selector__name'
        );


      if (name) {

        detailTitle.textContent =
          name.textContent.trim();

      }

    }


    /* ======================================================
       DESCRIPTION
       ====================================================== */

    section
      .querySelectorAll(
        '[data-tier-description]'
      )
      .forEach(function (description) {

        description.hidden =
          description.dataset.tierDescription !==
          selectedTier;

      });


    /* ======================================================
       PANEL STATUS
       ====================================================== */

    const status =
      section.querySelector(
        '[data-tier-detail-status]'
      );


    if (status) {

      if (
        currentTier &&
        selectedTier === currentTier
      ) {

        status.textContent =
          'Your Current Level';

      }

      else if (
        currentRank &&
        selectedRank < currentRank
      ) {

        status.textContent =
          'Previewing Level';

      }

      else if (
        currentRank &&
        selectedRank > currentRank
      ) {

        status.textContent =
          'Available to Unlock';

      }

      else {

        status.textContent =
          'Explore this level';

      }

    }


    /* ======================================================
       BENEFITS
       ====================================================== */

    section
      .querySelectorAll(
        '[data-tier-benefit]'
      )
      .forEach(function (benefit) {

        const requiredRank =
          parseInt(
            benefit.dataset.minimumRank,
            10
          ) || 1;


        const included =
          selectedRank >= requiredRank;


        benefit.classList.toggle(
          'is-active',
          included
        );


        benefit.classList.toggle(
          'is-locked',
          !included
        );


        const state =
          benefit.querySelector(
            '[data-benefit-state]'
          );


        if (!state) {
          return;
        }


        if (included) {

          if (
            currentTier &&
            selectedTier === currentTier
          ) {

            state.textContent =
              'Included for you';

          } else {

            state.textContent =
              'Included';

          }

        } else {

          const requiredTier =
            benefit.dataset.minimumTier;


          const requiredData =
            tierData[requiredTier];


          state.textContent =
            requiredData
              ? 'Available at ' +
                requiredData.label
              : 'Not included';

        }

      });


    /* ======================================================
       FOOTER / CTA
       ====================================================== */

    const footerTitle =
      section.querySelector(
        '[data-tier-footer-title]'
      );


    const footerCopy =
      section.querySelector(
        '[data-tier-footer-copy]'
      );


    const cta =
      section.querySelector(
        '[data-tier-cta]'
      );


    if (!cta) {
      return;
    }


    cta.classList.remove(
      'is-current',
      'is-included'
    );


    /* Always restore link first */

    if (selectedCta.link) {

      cta.setAttribute(
        'href',
        selectedCta.link
      );

    } else {

      cta.removeAttribute(
        'href'
      );

    }


    /* ======================================================
       CURRENT TIER
       ====================================================== */

    if (
      currentTier &&
      selectedTier === currentTier
    ) {

      if (footerTitle) {

        footerTitle.textContent =
          'You are here';

      }


      if (footerCopy) {

        footerCopy.textContent =
          'These are the benefits available at your current level.';

      }


      cta.textContent =
        'Your Current Level';


      cta.removeAttribute(
        'href'
      );


      cta.classList.add(
        'is-current'
      );


      return;

    }


    /* ======================================================
       LOWER TIER ALREADY INCLUDED
       ====================================================== */

    if (
      currentRank &&
      selectedRank < currentRank
    ) {

      if (footerTitle) {

        footerTitle.textContent =
          selectedData.label +
          ' Benefits';

      }


      if (footerCopy) {

        footerCopy.textContent =
          'This level is already included within your current membership.';

      }


      cta.textContent =
        'Already Included';


      cta.removeAttribute(
        'href'
      );


      cta.classList.add(
        'is-included'
      );


      return;

    }


    /* ======================================================
       AVAILABLE / UPGRADE TIER
       ====================================================== */

    if (footerTitle) {

      footerTitle.textContent =
        selectedData.label +
        ' Benefits';

    }


    if (footerCopy) {

      if (
        currentRank &&
        selectedRank > currentRank
      ) {

        footerCopy.textContent =
          'Take the next step to unlock the additional benefits available at this level.';

      } else {

        footerCopy.textContent =
          'See what is included at this level and take the next step when you are ready.';

      }

    }


    cta.textContent =
      selectedCta.label;


    if (selectedCta.link) {

      cta.setAttribute(
        'href',
        selectedCta.link
      );

    } else {

      cta.removeAttribute(
        'href'
      );

    }

  }


  function initializeTierExperience(
    section
  ) {

    if (
      section.dataset.tierInitialized ===
      'true'
    ) {
      return;
    }


    const selectors =
      section.querySelectorAll(
        '[data-tier-selector]'
      );


    if (!selectors.length) {
      return;
    }


    section.dataset.tierInitialized =
      'true';


    let currentTier =
      detectCurrentTier(section);


    let selectedTier =
      currentTier || 'basic';


    selectors.forEach(
      function (button) {

        button.addEventListener(
          'click',
          function () {

            section.dataset.userSelectedTier =
              'true';


            selectedTier =
              button.dataset.tierSelector;


            currentTier =
              detectCurrentTier(section) ||
              currentTier;


            renderTier(
              section,
              selectedTier,
              currentTier
            );

          }
        );

      }
    );


    renderTier(
      section,
      selectedTier,
      currentTier
    );


    /* ======================================================
       WAIT FOR LOYALTYLION
       ====================================================== */

    const observer =
      new MutationObserver(
        function () {

          const detected =
            detectCurrentTier(section);


          if (
            detected &&
            detected !== currentTier
          ) {

            currentTier =
              detected;


            if (
              !section.dataset.userSelectedTier
            ) {

              selectedTier =
                currentTier;

            }


            renderTier(
              section,
              selectedTier,
              currentTier
            );

          }

        }
      );


    const native =
      section.querySelector(
        '.loyalty-tiers__native-source'
      );


    if (native) {

      observer.observe(
        native,
        {
          childList: true,
          subtree: true
        }
      );

    }

  }


  function initAll() {

    document
      .querySelectorAll(
        '[data-loyalty-tier-experience]'
      )
      .forEach(
        initializeTierExperience
      );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );

  } else {

    initAll();

  }

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
